import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { neuart01 } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const GBAW01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Warhol GB-AW-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/GB-AW-01/FINEXITY_neuart-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 12/2020 - PDF - 276 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Warhol GB-AW-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/GB-AW-01/FINEXITY_neuart-01_Basisinformationsblatt.pdf`,
        description: "Stand 12/2020 - PDF - 210 KB",
    },
];

const DEGU01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Uecker DE-GU-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-GU-01/neuart-01_DE-GU-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2021 - PDF - 211 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Uecker DE-GU-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-GU-01/neuart-01_DE-GU-01_Basisinformationsblatt.pdf`,
        description: "Stand 02/2021 - PDF - 256 KB",
    },
];

const DEHM01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Mack DE-HM-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-HM-01/neuart-01_DE-HM-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2021 - PDF - 257 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Mack DE-HM-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-HM-01/neuart-01_DE-HM-01_Basisinformationsblatt.pdf`,
        description: "Stand 02/2021 - PDF - 209 KB",
    },
];

const DECH01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Christo DE-CH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-CH-01/neuart-01_DE-CH-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2021 - PDF - 256 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Christo DE-CH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-CH-01/neuart-01_DE-CH-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2021 - PDF - 210 KB",
    },
];

const DEML01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Lüpertz DE-ML-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-ML-01/neuart-01_DE-ML-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2021 - PDF - 260 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Lüpertz DE-ML-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-ML-01/neuart-01_DE-ML-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2021 - PDF - 212 KB",
    },
    {
        title: "Verlängerung Angebotszeitraum Lüpertz DE-ML-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-ML-01/FINEXITY_Verlaengerung_Angebotszeitraum_MLS-Token.pdf`,
        description: "Stand 07/2021 - PDF - 238 KB",
    },
];

const DEKH01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Haring DE-KH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-KH-01/neuart-01_DE-KH-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2021 - PDF - 232 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Haring DE-KH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-KH-01/neuart-01_DE-KH-01_Basisinformationsblatt.pdf`,
        description: "Stand 04/2021 - PDF - 102 KB",
    },
];

const DEAW02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Warhol DE-AW-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AW-02/FINEXITY_neuart-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2021 - PDF - 305 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Warhol DE-AW-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AW-02/FINEXITY_neuart-01_Basisinformationsblatt.pdf`,
        description: "Stand 06/2021 - PDF - 213 KB",
    },
];

const DEFP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FP-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-01/neuart-01_DE-FP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2021 - PDF - 279 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FP-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-01/neuart-01_DE-FP-01_Basisinformationsblatt.pdf`,
        description: "Stand 06/2021 - PDF - 218 KB",
    },
];

const DEFY01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FY-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FY-01/neuart-01_DE-FY-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2021 - PDF - 272 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FY-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FY-01/neuart-01_DE-FY-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2021 - PDF - 218 KB",
    },
];

const DEAW03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen Warhol DE-AW-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AW-03/FINEXITY_neuart-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2021 - PDF - 282 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* Warhol DE-AW-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AW-03/FINEXITY_neuart-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2021 - PDF - 213 KB",
    },
];

const DEAK01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen AKC DE-AK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AK-01/neuart-01_DE-AK-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2021 - PDF - 282 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* AKC DE-AK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AK-01/neuart-01_DE-AK-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2021 - PDF - 214 KB",
    },
];

const DEFG01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FG-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-01/neuart-01_DE-FG-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2021 - PDF - 278 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FG-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-01/neuart-01_DE-FG-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2021 - PDF - 219 KB",
    },
];

const DEGU02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen UBS DE-GU-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-GU-02/neuart-01_DE-GU-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2021 - PDF - 281 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* UBS DE-GU-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-GU-02/neuart-01_DE-GU-02_Basisinformationsblatt.pdf`,
        description: "Stand 08/2021 - PDF - 215 KB",
    },
];

const DEWE01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-WE-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-WE-01/neuart-01_DE-WE-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2021 - PDF - 279 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-WE-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-WE-01/neuart-01_DE-WE-01_Basisinformationsblatt.pdf`,
        description: "Stand 08/2021 - PDF - 213 KB",
    },
];

const DEFB01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FB-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FB-01/neuart-01_DE-FB-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2021 - PDF - 281 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FB-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FB-01/neuart-01_DE-FB-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2021 - PDF - 217 KB",
    },
];

const DEJK01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-JK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-JK-01/neuart-01_DE-JK-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2021 - PDF - 281 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-JK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-JK-01/neuart-01_DE-JK-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2021 - PDF - 217 KB",
    },
];

const DEFG02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FG-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-02/neuart-01_DE-FG-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2021 - PDF - 283 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FG-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-02/neuart-01_DE-FG-02_Basisinformationsblatt.pdf`,
        description: "Stand 09/2021 - PDF - 224 KB",
    },
];

const DEAI01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-AI-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AI-01/neuart-01_DE-AI-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2021 - PDF - 283 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-AI-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AI-01/neuart-01_DE-AI-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2021 - PDF - 218 KB",
    },
];

const DEFB02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FB-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FB-02/neuart-01_DE-FB-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2021 - PDF - 282 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FB-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FB-02/neuart-01_DE-FB-02_Basisinformationsblatt.pdf`,
        description: "Stand 10/2021 - PDF - 226 KB",
    },
];

const DEAI02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-AI-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AI-02/neuart-01_DE-AI-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2021 - PDF - 284 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-AI-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AI-02/neuart-01_DE-AI-02_Basisinformationsblatt.pdf`,
        description: "Stand 10/2021 - PDF - 218 KB",
    },
];

const DETD01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-TD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-TD-01/neuart-01_DE-TD-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2021 - PDF - 295 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-TD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-TD-01/neuart-01_DE-TD-01_Basisinformationsblatt.pdf`,
        description: "Stand 11/2021 - PDF - 223 KB",
    },
];

const DEJK02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-JK-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-JK-02/neuart-01_DE-JK-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2021 - PDF - 287 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-JK-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-JK-02/neuart-01_DE-JK-02_Basisinformationsblatt.pdf`,
        description: "Stand 11/2021 - PDF - 218 KB",
    },
];

const DEKA01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-KA-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-KA-01/neuart-01_DE-KA-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2021 - PDF - 282 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-KA-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-KA-01/neuart-01_DE-KA-01_Basisinformationsblatt.pdf`,
        description: "Stand 11/2021 - PDF - 212 KB",
    },
];

const DEFY02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FY-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FY-02/neuart-01_DE-FY-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2021 - PDF - 283 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FY-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FY-02/neuart-01_DE-FY-02_Basisinformationsblatt.pdf`,
        description: "Stand 11/2021 - PDF - 225 KB",
    },
];

const DEPM01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-PM-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-PM-01/neuart-01_DE-PM-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 12/2021 - PDF - 286 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PM-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-PM-01/neuart-01_DE-PM-01_Basisinformationsblatt.pdf`,
        description: "Stand 12/2021 - PDF - 219 KB",
    },
];

const DEFP02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FP-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-02/neuart-01_DE-FP-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 12/2021 - PDF - 285 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FP-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-02/neuart-01_DE-FP-02_Basisinformationsblatt.pdf`,
        description: "Stand 12/2021 - PDF - 225 KB",
    },
];

const DERI01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-RI-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-RI-01/neuart-01_DE-RI-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2022 - PDF - 287 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-RI-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-RI-01/neuart-01_DE-RI-01_Basisinformationsblatt.pdf`,
        description: "Stand 01/2022 - PDF - 218 KB",
    },
];

const DEFG03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FG-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-03/neuart-01_DE-FG-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2022 - PDF - 285 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FG-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-03/neuart-01_DE-FG-03_Basisinformationsblatt.pdf`,
        description: "Stand 01/2022 - PDF - 225 KB",
    },
];

const DEFP03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FP-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-03/neuart-01_DE-FP-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2022 - PDF - 280 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FP-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-03/neuart-01_DE-FP-03_Basisinformationsblatt.pdf`,
        description: "Stand 02/2022 - PDF - 218 KB",
    },
];

const DEKA02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-KA-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-KA-02/neuart-01_DE-KA-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2022 - PDF - 281 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-KA-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-KA-02/neuart-01_DE-KA-02_Basisinformationsblatt.pdf`,
        description: "Stand 02/2022 - PDF - 210 KB",
    },
];

const DEFO01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FO-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FO-01/neuart-01_DE-FO-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2022 - PDF - 281 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FO-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FO-01/neuart-01_DE-FO-01_Basisinformationsblatt.pdf`,
        description: "Stand 02/2022 - PDF - 207 KB",
    },
];

const DEAP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-AP-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AP-01/neuart-01_DE-AP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2022 - PDF - 256 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-AP-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AP-01/neuart-01_DE-AP-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2022 - PDF - 203 KB",
    },
];

const DEFP04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FP-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-04/neuart-01_DE-FP-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2022 - PDF - 261 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FP-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-04/neuart-01_DE-FP-04_Basisinformationsblatt.pdf`,
        description: "Stand 03/2022 - PDF - 208 KB",
    },
];

const DEDH01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-DH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-DH-01/neuart-01_DE-DH-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2022 - PDF - 289 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-DH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-DH-01/neuart-01_DE-DH-01_Basisinformationsblatt.pdf`,
        description: "Stand 04/2022 - PDF - 200 KB",
    },
];

const DEFG04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FG-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-04/neuart-01_DE-FG-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2022 - PDF - 269 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FG-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FG-04/neuart-01_DE-FG-04_Basisinformationsblatt.pdf`,
        description: "Stand 04/2022 - PDF - 218 KB",
    },
];

const DEFP05DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FP-05",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-05/neuart-01_DE-FP-05_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2022 - PDF - 284 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FP-05",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-05/neuart-01_DE-FP-05_Basisinformationsblatt.pdf`,
        description: "Stand 05/2022 - PDF - 201 KB",
    },
];

const DEAW04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-AW-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AW-04/neuart-01_DE-AW-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2022 - PDF - 262 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-AW-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-AW-04/neuart-01_DE-AW-04_Basisinformationsblatt.pdf`,
        description: "Stand 05/2022 - PDF - 200 KB",
    },
];

const DEBA01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-BA-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-BA-01/neuart-01_DE-BA-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2022 - PDF - 260 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-BA-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-BA-01/neuart-01_DE-BA-01_Basisinformationsblatt.pdf`,
        description: "Stand 06/2022 - PDF - 199 KB",
    },
];

const DEWD01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-WD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-WD-01/neuart-01_DE-WD-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 06/2022 - PDF - 280 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-WD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-WD-01/neuart-01_DE-WD-01_Basisinformationsblatt.pdf`,
        description: "Stand 06/2022 - PDF - 202 KB",
    },
];

const DERL01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-RL-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-RL-01/neuart-01_DE-RL-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 262 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-RL-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-RL-01/neuart-01_DE-RL-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 198 KB",
    },
];

const DEPD01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-PD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-PD-01/neuart-01_DE-PD-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 268 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-PD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-PD-01/neuart-01_DE-PD-01_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 200 KB",
    },
];

const DEFO02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FO-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FO-02/neuart-01_DE-FO-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 07/2022 - PDF - 283 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FO-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FO-02/neuart-01_DE-FO-02_Basisinformationsblatt.pdf`,
        description: "Stand 07/2022 - PDF - 202 KB",
    },
];

const DEFP06DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-FP-06",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-06/neuart-01_DE-FP-06_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2022 - PDF - 285 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-FP-06",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DE-FP-06/neuart-01_DE-FP-06_Basisinformationsblatt.pdf`,
        description: "Stand 08/2022 - PDF - 203 KB",
    },
];

const DIFP01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DI-FP-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FP-01/neuart-01_DI-FP-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2022 - PDF - 279 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DI-FP-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FP-01/neuart-01_DI-FP-01_Basisinformationsblatt.pdf`,
        description: "Stand 08/2022 - PDF - 201 KB",
    },
];

const FABA01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FA-BA-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-BA-01/neuart-01_FA-BA-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2022 - PDF - 262 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FA-BA-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-BA-01/neuart-01_FA-BA-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2022 - PDF - 200 KB",
    },
];

const FAJS01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FA-JS-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-JS-01/neuart-01_FA-JS-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2022 - PDF - 261 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FA-JS-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-JS-01/neuart-01_FA-JS-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 199 KB",
    },
];

const FAEH01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FA-EH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-EH-01/neuart-01_FA-EH-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2022 - PDF - 268 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FA-EH-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-EH-01/neuart-01_FA-EH-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 210 KB",
    },
];

const FAGU01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FA-GU-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-GU-01/neuart-01_FA-GU-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2022 - PDF - 262 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FA-GU-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-GU-01/neuart-01_FA-GU-01_Basisinformationsblatt.pdf`,
        description: "Stand 10/2022 - PDF - 199 KB",
    },
];

const DIFY01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DI-FY-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FY-01/neuart-01_DI-FY-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 11/2022 - PDF - 277 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DI-FY-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FY-01/neuart-01_DI-FY-01_Basisinformationsblatt.pdf`,
        description: "Stand 11/2022 - PDF - 202 KB",
    },
];

const DIFP02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DI-FP-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FP-02/neuart-01_DI-FP-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 12/2022 - PDF - 281 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DI-FP-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FP-02/neuart-01_DI-FP-02_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 203 KB",
    },
];

const FABA02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FA-BA-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-BA-02/neuart-01_FA-BA-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2023 - PDF - 189 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FA-BA-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-BA-02/neuart-01_FA-BA-02_Basisinformationsblatt.pdf`,
        description: "Stand 01/2023 - PDF - 128 KB",
    },
];

const CDPPFABA02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FA-BA-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-BA-02/neuart-01_CD-PP-FA-BA-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2023 - PDF - 188 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FA-BA-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-BA-02/neuart-01_CD-PP-FA-BA-02_Basisinformationsblatt.pdf`,
        description: "Stand 01/2023 - PDF - 128 KB",
    },
];

const DIFP03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DI-FP-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FP-03/neuart-01_DI-FP-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 01/2023 - PDF - 287 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DI-FP-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-FP-03/neuart-01_DI-FP-03_Basisinformationsblatt.pdf`,
        description: "Stand 02/2023 - PDF - 124 KB",
    },
];

const FAIK01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FA-IK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-IK-01/neuart-01_FA-IK-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2023 - PDF - 174 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FA-IK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-IK-01/neuart-01_FA-IK-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2023 - PDF - 129 KB",
    },
];

const CDPPFAIK01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FA-IK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-IK-01/neuart-01_CD-PP-FA-IK-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2023 - PDF - 188 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FA-IK-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-IK-01/neuart-01_CD-PP-FA-IK-01_Basisinformationsblatt.pdf`,
        description: "Stand 03/2023 - PDF - 128 KB",
    },
];

const CDPPDIRD01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-DI-RD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-DI-RD-01/neuart-01_CD-PP-DI-RD-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2023 - PDF - 262 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-DI-RD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-DI-RD-01/neuart-01_CD-PP-DI-RD-01_Basisinformationsblatt.pdf`,
        description: "Stand 04/2023 - PDF - 185 KB",
    },
];

const CDPPFASB01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FA-SB-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-SB-01/neuart-01_CD-PP-FA-SB-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 04/2023 - PDF - 135 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FA-SB-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-SB-01/neuart-01_CD-PP-FA-SB-01_Basisinformationsblatt.pdf`,
        description: "Stand 04/2023 - PDF - 188 KB",
    },
];

const FAJY01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen FA-JY-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-JY-01/neuart-01_FA-JY-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2023 - PDF - 236 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* FA-JY-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/FA-JY-01/neuart-01_FA-JY-01_Basisinformationsblatt.pdf`,
        description: "Stand 08/2023 - PDF - 124 KB",
    },
];

const DIWD01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DI-WD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-WD-01/neuart-01_DI-WD-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2023 - PDF - 282 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DI-WD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/DI-WD-01/neuart-01_DI-WD-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2023 - PDF - 122 KB",
    },
];

const CDPPDIWD01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-DI-WD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-DI-WD-01/neuart-01_CD-PP-DI-WD-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 09/2023 - PDF - 283 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-DI-WD-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-DI-WD-01/neuart-01_CD-PP-DI-WD-01_Basisinformationsblatt.pdf`,
        description: "Stand 09/2023 - PDF - 123 KB",
    },
];

const CDPPFATC01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FA-TC-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-01/neuart-01_CD-PP-FA-TC-01_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 10/2023 - PDF - 130 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FA-TC-01",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-01/neuart-01_CD-PP-FA-TC-01_Basisinformationsblatt.pdf`,
        description: "Stand 10/2023 - PDF - 188 KB",
    },
];

const CDPPFATC02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FA-TC-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-02/neuart-01_CD-PP-FA-TC-02_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2024 - PDF - 166 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FA-TC-02",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-02/neuart-01_CD-PP-FA-TC-02_Basisinformationsblatt.pdf`,
        description: "Stand 05/2024 - PDF - 248 KB",
    },
];

const CDPPFATC03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FA-TC-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-03/neuart-01_CD-PP-FA-TC-03_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2024 - PDF - 160 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FA-TC-03",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-03/neuart-01_CD-PP-FA-TC-03_Basisinformationsblatt.pdf`,
        description: "Stand 05/2024 - PDF - 288 KB",
    },
];

const CDPPFATC04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-FA-TC-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-04/neuart-01_CD-PP-FA-TC-04_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 05/2024 - PDF - 140 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-FA-TC-04",
        path: `${DOCUMENT_HOST}/docs/general/neuart/CD-PP-FA-TC-04/neuart-01_CD-PP-FA-TC-04_Basisinformationsblatt.pdf`,
        description: "Stand 05/2024 - PDF - 208 KB",
    },
];

const Neuprop0405 = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(neuart01.title)}</title>

                <meta name="description" content="neuart - 01 GmbH & Co. KG" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/neuarBg.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/logo-neuart-01.png"} alt="" />
                        </div>
                        <p>Der Unternehmensgegenstand der Gesellschaft besteht in dem Erwerb und dem Halten von Kunst.</p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>neuart - 01 GmbH & Co. KG</h2>
                        <p>
                            Bei der Finanzierung verfolgt die neuart - 01 GmbH & Co. KG eine langfristig ausgerichtete Strategie.
                        </p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={GBAW01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEGU01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEHM01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DECH01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEML01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEKH01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAW02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFY01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAW03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAK01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFG01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEGU02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEWE01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFB01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEJK01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFG02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAI01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFB02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAI02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DETD01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEJK02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEKA01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFY02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEPM01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFP02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DERI01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFG03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFP03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEKA02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFO01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFP04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEDH01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFG04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFP05DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEAW04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEBA01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEWD01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DERL01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEPD01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFO02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEFP06DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DIFP01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FABA01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DIFP02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FAJS01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FAEH01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FAGU01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DIFY01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DIFP02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FABA02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFABA02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DIFP03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FAIK01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFAIK01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPDIRD01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFASB01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={FAJY01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DIWD01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPDIWD01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFATC01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFATC02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFATC03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPFATC04DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:neuart-01@finexity.com">neuart-01@finexity.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Neuprop0405;
